import React from 'react';
import MuiThemeProvider from './src/components/MuiThemeProvider';
import './src/styles/global.css';

export const wrapRootElement = ({ element }) => {
  return React.createElement(MuiThemeProvider, {}, element);
};

// scroll to top when the client route changes
export const onRouteUpdate = ({ location, prevLocation }) => {
  if (location?.pathname && prevLocation?.pathname && location?.pathname !== prevLocation?.pathname) {
    document.getElementById('___gatsby')?.scrollIntoView({
      behavior: 'instant',
      block: 'start',
      inline: 'nearest',
    });
  }
};
